export var OrderStatus = /* @__PURE__ */ ((OrderStatus2) => {
  OrderStatus2["processing"] = "processing";
  OrderStatus2["shipping"] = "shipping";
  OrderStatus2["delivered"] = "delivered";
  OrderStatus2["canceled"] = "canceled";
  return OrderStatus2;
})(OrderStatus || {});
export const defaultOrderStatusMap = {
  processing: [
    "processing",
    "pending_payment",
    "payment_review",
    "pending_paypal",
    "paypal_reversed"
  ],
  shipping: ["pending", "STATE_OPEN", "closed"],
  canceled: ["canceled", "paypay_canceled_reversal"],
  delivered: ["complete"]
};
let activeMapper = defaultOrderStatusMap;
export function useConfigOrderStatusMapper() {
  function setOrderStatusMapper(mapper) {
    activeMapper = mapper;
  }
  function getOrderStatusMapper() {
    return activeMapper;
  }
  return {
    setOrderStatusMapper,
    getOrderStatusMapper
  };
}
